var User = /** @class */ (function () {
    function User(userPermissionsResponse) {
        this.permissions = userPermissionsResponse.permissions.map(function (permission) { return permission.permissionId; });
        this.roles = userPermissionsResponse.roles.map(function (role) { return role.roleId; });
    }
    User.prototype.hasRole = function (role) {
        return this.roles.includes(role);
    };
    User.prototype.hasPermission = function (permission) {
        return this.permissions.includes(permission);
    };
    return User;
}());
export { User };
var UserChartAccess = /** @class */ (function () {
    function UserChartAccess(userAccessLinked, chartAccessRestrictionEnabled, clinicalDataAccessRestrictionEnabled, patientRestricted) {
        this.userAccessLinked = userAccessLinked;
        this.chartAccessRestrictionEnabled = chartAccessRestrictionEnabled;
        this.clinicalDataAccessRestrictionEnabled = clinicalDataAccessRestrictionEnabled;
        this.patientRestricted = patientRestricted;
    }
    UserChartAccess.prototype.dataRestrictionEnabled = function () {
        return this.clinicalDataAccessRestrictionEnabled;
    };
    UserChartAccess.prototype.protectionEnabled = function () {
        return (this.clinicalDataAccessRestrictionEnabled ||
            this.chartAccessRestrictionEnabled);
    };
    return UserChartAccess;
}());
export { UserChartAccess };
export var FeatureSetValue;
(function (FeatureSetValue) {
    FeatureSetValue["ENABLED"] = "ENABLED";
    FeatureSetValue["HIDDEN"] = "HIDDEN";
})(FeatureSetValue || (FeatureSetValue = {}));
export var FeatureSetType;
(function (FeatureSetType) {
    FeatureSetType["CLINICAL"] = "feature-set.product.clinical";
    FeatureSetType["BILLING"] = "feature-set.product.billing";
    FeatureSetType["RECALL"] = "feature-set.area.patient-recall";
    FeatureSetType["DOCUMENTS"] = "feature-set.area.documents";
})(FeatureSetType || (FeatureSetType = {}));
